<template>
  <n-card title="Income Management">
    <n-space vertical>
      <n-table :bordered="false" :single-line="false">
        <thead>
          <tr>
            <th>Name</th>
            <th>Amount</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="income in incomes" :key="income.id">
            <td>{{ income.name }}</td>
            <td>{{ formatCurrency(income.amount) }}</td>
            <td>{{ formatDate(income.date) }}</td>
            <td>
              <n-space>
                <n-button size="small" @click="editIncome(income)">Edit</n-button>
                <n-button size="small" type="error" @click="deleteIncome(income.id)">Delete</n-button>
              </n-space>
            </td>
          </tr>
        </tbody>
      </n-table>
      <n-button @click="showIncomeForm = true">Add Income</n-button>
      <n-modal 
        v-model:show="showIncomeForm"
        preset="card"
        :mask-closable="true" 
        :title="isEditing ? 'Edit Income' : 'Add Income'"
        style="width: 60%; max-width: 600px"
      >
        <n-form 
          ref="formRef" 
          :model="formIncome" 
          label-placement="left"
          label-width="100"
        >
          <n-form-item label="Name" path="name">
            <n-input v-model:value="formIncome.name" />
          </n-form-item>
          <n-form-item label="Date" path="date">
            <n-date-picker 
              v-model:value="formIncome.date" 
              type="date"
            />
          </n-form-item>
          <n-form-item label="Amount" path="amount">
            <n-input-number 
              v-model:value="formIncome.amount" 
              :min="0"
              :precision="2"
              style="width: 100%"
            />
          </n-form-item>
          <div style="text-align: right">
            <n-button type="primary" @click="submitForm">
              {{ isEditing ? 'Update' : 'Add' }}
            </n-button>
          </div>
        </n-form>
      </n-modal>
    </n-space>
  </n-card>
</template>

<script setup>
import { useIncomeStore } from '../stores/incomeStore';
import { formatCurrency, formatDate } from '../utils/format';
import { onMounted, computed, ref } from 'vue';

const incomeStore = useIncomeStore();
const incomes = computed(() => incomeStore.incomes);
const showIncomeForm = ref(false);
const isEditing = ref(false);
const editingId = ref(null);
const formIncome = ref({
  name: '',
  amount: 0,
  date: null
});

onMounted(() => {
  incomeStore.fetchIncomes();
});


const resetForm = () => {
  formIncome.value = {
    name: '',
    amount: 0,
    date: null
  };
  isEditing.value = false;
  editingId.value = null;
  showIncomeForm.value = false;
};

const deleteIncome = async (id) => {
  try {
    await incomeStore.deleteIncome(id);
  } catch (error) {
    console.error('Error deleting income:', error);
  }
};

const editIncome = (income) => {
  isEditing.value = true;
  editingId.value = income.id;
  formIncome.value = {
    ...income,
    date: income.date ? new Date(income.date).getTime() : null
  };
  showIncomeForm.value = true;
};

const submitForm = async () => {
  try {
    if (isEditing.value) {
      await incomeStore.updateIncome(editingId.value, formIncome.value);
    } else {
      await incomeStore.addIncome(formIncome.value);
    }
    resetForm();
  } catch (error) {
    console.error('Error submitting form:', error);
  }
};
</script>